import * as React from 'react';
import { style } from 'typestyle';

import { CommonStyles } from '~src/common/react/CommonStyles';
import { IRemoteQueryAgent, RemoteAgentConnectionStatus } from '~src/settings/types/ISiteAdminBridgeSettings';
import { IRemoteAgentConnectionStatus } from '~src/ts/ServerApi/requests/GetSiteRemoteAgentsConnectionStatusRequest';

import { getAgentStatus } from '../BridgeRemoteAgentsSection/BridgeRemoteAgentsPresenceIcon';
import { UserDefinedPoolModel } from '../types/PoolModel';
import { DeletePoolButton } from './DeletePoolButton';
import { EditPoolButton } from './EditPoolButton';
import { PoolStatusIcon } from './PoolStatusIcon';

export type MultiPoolTableEntryPoolProps = Readonly<{
  pool: UserDefinedPoolModel;
  existingPoolNames: ReadonlyArray<string>;
  isExpanded: boolean;
  connectionStatuses: IRemoteAgentConnectionStatus[];
  siteId: string;
  refreshEdgePools: () => void;
}>;

export function BridgeMultiPoolTableEntryPool(props: MultiPoolTableEntryPoolProps) {
  const { pool, existingPoolNames, isExpanded, connectionStatuses, siteId, refreshEdgePools } = props;
  const agents: IRemoteQueryAgent[] = Object.values(pool.agents);
  let poolStyle = 'tb-data-grid-separator-row ';
  poolStyle += isExpanded ? expandedRowFocus : '';

  return <>
    <td className={poolStyle}>
      <span className={'tb-data-grid-cell-text tb-lr-padded-wide'} data-tb-test-id={'pool-name-cell'}>
        {pool.displayName}
      </span>
    </td>
    <td className={poolStyle}>
      <span className={'tb-data-grid-cell-text tb-lr-padded-wide'} data-tb-test-id={'pool-all-clients-cell'}>
        {agents.length}
      </span>
    </td>
    <td className={poolStyle}>
      <span className={'tb-data-grid-cell-text tb-lr-padded-wide'} data-tb-test-id={'pool-active-clients-cell'}>
        {getActiveAgentCount(agents, connectionStatuses)}
      </span>
    </td>
    <td className={poolStyle}>
      <span className={'tb-data-grid-cell-text tb-lr-padded-wide'} data-tb-test-id={'pool-status-cell'}>
        {<PoolStatusIcon pool={pool} connectionStatuses={connectionStatuses} />}
      </span>
    </td>
    <td className={poolStyle}>
      {!isExpanded && <>
        <EditPoolButton pool={pool} existingPoolNames={existingPoolNames} siteId={siteId} refreshEdgePools={refreshEdgePools} />
        <DeletePoolButton pool={pool} siteId={siteId} refreshEdgePools={refreshEdgePools} />
      </>}
    </td>
  </>;
}

function getActiveAgentCount(agents: IRemoteQueryAgent[], connectionStatuses: IRemoteAgentConnectionStatus[]) {
  return agents.filter(
    agent => getAgentStatus(agent, connectionStatuses)?.connectionStatus === RemoteAgentConnectionStatus.CONNECTED
  ).length;
}

export const expandedRowFocus = style({
  backgroundColor: CommonStyles.Colors.BlueHighlight
});
